<template>
    <div>
      <font-awesome-icon
        :icon="['fas', result.icon]"
        :class="result.color"
      />
      <span
        class="report__resultRow__text"
      >{{$t('report.measured')}}: {{ccaMeasured}} CCA</span>
    </div>
</template>

<script>
    export default {
      name: "CcaMeasured",
      props: ['overallResult', 'ccaMeasured'],
      data() {
        return {
          overallResultMap: [
            {
              code: 0,
              icon: "times-circle",
              color: "red-icon",
              message: this.$t('report.badCondition')
            },
            {
              code: 1,
              icon: "check-circle",
              color: "yellow-icon",
              message: this.$t('report.goodCondition')
            },
            //last item is default
            {
              code: 'default',
              icon: "check-circle",
              color: "green-icon",
              message: this.$t('report.goodCondition')
            }
          ]
        }
      },
      computed: {
        result: function() {
          for (let index in this.overallResultMap) {
            if(this.overallResult == this.overallResultMap[index].code) {
              // console.log(this.overallResultMap[index]);
              return this.overallResultMap[index];
            }
          }
          return this.overallResultMap[this.overallResultMap.length - 1];
        }
      }
    }
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

svg {
  margin-right: 15px;
}

.red-icon {
  color: $red;
}

.green-icon {
  color: $green;
}

.yellow-icon {
  color: $orange;
}

.blue-icon {
  color: $primary;
}
</style>
